/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Load_ErrorInputs */

const en_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the practice library.`)
};

const es_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la biblioteca de práctica.`)
};

const de_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Übungsbibliothek konnte nicht geladen werden.`)
};

const zh_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载练习库。`)
};

const ar_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل مكتبة التدريب.`)
};

const fr_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la bibliothèque d'exercices.`)
};

const vi_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải thư viện luyện tập.`)
};

const sw_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kupakia maktaba ya mazoezi.`)
};

const th_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดไลบรารีแบบฝึกหัดได้`)
};

const bs_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nije moguće učitati biblioteku vježbi.`)
};

const ja_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習ライブラリを読み込めませんでした。`)
};

const ko_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습 라이브러리를 불러오지 못했습니다.`)
};

const pt_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a biblioteca de prática.`)
};

const it_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la libreria di esercizi.`)
};

const sv_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det gick inte att läsa in övningsbiblioteket.`)
};

const nl_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon de oefenbibliotheek niet laden.`)
};

const da_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlæse øvelsesbiblioteket.`)
};

const nb_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klarte ikke å laste øvingsbiblioteket.`)
};

const fi_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskirjastoa ei voitu ladata.`)
};

const pl_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wczytać biblioteki ćwiczeń.`)
};

const ru_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить библиотеку упражнений.`)
};

const tr_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman kütüphanesi yüklenemedi.`)
};

const hi_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास लाइब्रेरी लोड नहीं हो सकी।`)
};

const id_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka latihan tidak dapat dimuat.`)
};

const ms_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat memuatkan pustaka latihan.`)
};

const cs_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knihovnu cvičení se nepodařilo načíst.`)
};

const el_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αδυναμία φόρτωσης της βιβλιοθήκης εξάσκησης.`)
};

const he_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא ניתן לטעון את ספריית התרגול.`)
};

const af_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon nie die oefenbiblioteek laai nie.`)
};

const hu_practice_load_error = /** @type {(inputs: Practice_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem sikerült betölteni a gyakorlókönyvtárat.`)
};

/**
* | output |
* | --- |
* | "Could not load the practice library." |
*
* @param {Practice_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_load_error = /** @type {((inputs?: Practice_Load_ErrorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Load_ErrorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_load_error(inputs)
	if (locale === "de") return de_practice_load_error(inputs)
	if (locale === "zh") return zh_practice_load_error(inputs)
	if (locale === "ar") return ar_practice_load_error(inputs)
	if (locale === "fr") return fr_practice_load_error(inputs)
	if (locale === "vi") return vi_practice_load_error(inputs)
	if (locale === "sw") return sw_practice_load_error(inputs)
	if (locale === "th") return th_practice_load_error(inputs)
	if (locale === "bs") return bs_practice_load_error(inputs)
	if (locale === "ja") return ja_practice_load_error(inputs)
	if (locale === "ko") return ko_practice_load_error(inputs)
	if (locale === "pt") return pt_practice_load_error(inputs)
	if (locale === "it") return it_practice_load_error(inputs)
	if (locale === "sv") return sv_practice_load_error(inputs)
	if (locale === "nl") return nl_practice_load_error(inputs)
	if (locale === "da") return da_practice_load_error(inputs)
	if (locale === "nb") return nb_practice_load_error(inputs)
	if (locale === "fi") return fi_practice_load_error(inputs)
	if (locale === "pl") return pl_practice_load_error(inputs)
	if (locale === "ru") return ru_practice_load_error(inputs)
	if (locale === "tr") return tr_practice_load_error(inputs)
	if (locale === "hi") return hi_practice_load_error(inputs)
	if (locale === "id") return id_practice_load_error(inputs)
	if (locale === "ms") return ms_practice_load_error(inputs)
	if (locale === "cs") return cs_practice_load_error(inputs)
	if (locale === "el") return el_practice_load_error(inputs)
	if (locale === "he") return he_practice_load_error(inputs)
	if (locale === "af") return af_practice_load_error(inputs)
	if (locale === "hu") return hu_practice_load_error(inputs)
	return en_practice_load_error(inputs)
});